import { ArrowDown, ArrowUp } from 'lucide-react';
import { formatPercent } from '../../utils/money';

const arrows = {
  up: ArrowUp,
  down: ArrowDown,
};

const deltaStyles = {
  improved: 'bg-success-500/10 text-success-700',
  worsened: 'bg-danger-500/10 text-danger-700',
  neutral: 'bg-secondary-500/10 text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor',
};

const DeltaBadge = ({ deltaPct, direction, isImprovement }) => {
  if (deltaPct === null || deltaPct === undefined) {
    return <span className={`badge ${deltaStyles.neutral}`}>New</span>;
  }
  if (direction === 'flat') {
    return <span className={`badge ${deltaStyles.neutral}`}>{formatPercent(deltaPct)}</span>;
  }

  const Arrow = arrows[direction];
  const style = isImprovement ? deltaStyles.improved : deltaStyles.worsened;

  return (
    <span className={`badge inline-flex items-center gap-1 ${style}`}>
      {Arrow && <Arrow className="w-3 h-3" aria-hidden="true" />}
      {formatPercent(Math.abs(deltaPct))}
    </span>
  );
};

export default DeltaBadge;
